// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Nz-z","tooltipWrapper":"Oz-z","icon":"Pz-z","tooltip":"Qz-z","content":"Rz-z"};